import request from '@/utils/request'
const BASE_URL = '/TradeUnitGoods'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  addGoods(data) {
    return request({
      url: BASE_URL + '/AddGoods',
      method: 'post',
      data
    })
  },
  updateStatus(data) {
    return request({
      url: BASE_URL + '/UpdateStatus',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
}